import { EXEC_MODE } from "cfg";
import React from "react";


const logAnalyticData = ({ event, siteSection, pageName, server, website } : any, userData: any = {}) => {
    (window as any)['adobeDataLayer'] = (window as any)['adobeDataLayer'] || [];
    (window as any)['adobeDataLayer'].push({
        "event":event,
        "pageInfo": {
            "siteSection":siteSection,
            "pageName":pageName,
            "server":server,
            "website":EXEC_MODE,
        },
        "userInfo": {
            benefitLevel:sessionStorage.getItem('BenefitLevel'),
            customerID:sessionStorage.getItem('OWNER_NUMBER'),
            ...userData

        }
    });
};

const trackAnalyticData = (name: string) => {
    (window as any)['_satellite'] && (window as any)['_satellite'].track(name);
}

export { logAnalyticData, trackAnalyticData };